import { Box, Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import clsx from 'clsx';
import useWindowDimensions from 'hooks/useWindowWidth';
import React from 'react';
import palette from 'theme/palette';
import styles from './styles';

const useStyles = makeStyles(styles);

interface LegendProps {
  color: string;
  label: string;
  count: number;
  tooltip: string;
  isConfig?: boolean;
  isSelected: boolean;
  value: string;
  handleClick: (filterValue: string) => void;
}

const Legend = ({
  color,
  label,
  count,
  tooltip,
  isConfig,
  isSelected,
  value,
  handleClick,
}: LegendProps) => {
  const classes = useStyles();

  const { width } = useWindowDimensions();

  return (
    <Grid item className={classes.displayFlex}>
      <div
        style={{
          height: 10,
          width: 20,
          minWidth: 20,
          border: `1px solid ${color}`,
          backgroundColor: color,
          margin: '0px 4px',
        }}
      ></div>
      <Typography
        onClick={() => {
          if (!isConfig) {
            handleClick(isSelected ? '' : value);
          }
        }}
        className={clsx(classes.title, {
          [classes.titleSelected]: !isConfig && isSelected,
          [classes.titleConfig]: isConfig,
        })}
        component="div"
      >
        <Tooltip arrow title={label}>
          <p
            className={clsx(classes.label, {
              [classes.labelSmall]: width < 1400,
            })}
          >{`${label}: `}</p>
        </Tooltip>
        {!isConfig ? (
          <Tooltip arrow title={tooltip}>
            <Box
              color={isSelected ? palette.green : palette.blue}
              fontWeight="bold"
              display="flex"
              alignItems="center"
            >
              {count || 0}
              {isSelected ? (
                <PlaylistAddCheckIcon className={classes.filterIconGreen} />
              ) : (
                <FilterListIcon className={classes.filterIcon} />
              )}
            </Box>
          </Tooltip>
        ) : (
          <Box
            color={palette.blue}
            fontWeight="bold"
            display="flex"
            alignItems="center"
          >
            {count || 0}
          </Box>
        )}
      </Typography>
    </Grid>
  );
};

export default Legend;
